<script setup lang="ts">
import { useScreensizeStore } from '@stores/useScreensizeStore.ts';
import SliderUp from './Sliderup.vue';
import SlideIn from './Slidein.vue';

withDefaults(defineProps<{
  isOpen: boolean,
  isClosableFromOverlay?: boolean,
}>(), {
  isClosableFromOverlay: true,
});

const emit = defineEmits<{(event: 'close'): void;
}>();

const { isMobile } = useScreensizeStore();
</script>

<template>
  <component
    :is="isMobile ? SliderUp : SlideIn"
    :is-opened="isOpen"
    :is-closable-from-overlay="isClosableFromOverlay"
    class="slider-offer-proposal"
    @close="emit('close')"
  >
    <template #header>
      <slot name="header" />
    </template>

    <template #body>
      <slot name="body" />
    </template>

    <template #footer>
      <slot name="footer" />
    </template>
  </component>
</template>
